module.exports = __webpack_public_path__ + "static/media/-1.ab2d6a27.png";